<template>
    <Tabs type="card">
        <TabPane label="百信">
			<BaixinData ref="BaixinData"></BaixinData>
		</TabPane>
		<TabPane label="畅开花" >
			<ChangkaihuaData ref="ChangkaihuaData"></ChangkaihuaData>
		</TabPane>
    </Tabs>	
</template>

<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import ToutiaoAdvData from './ToutiaoAdvData.vue';
	import BaixinData from './BaixinData.vue';
	import ChangkaihuaData from '../advManage/ChangkaihuaData.vue';
	export default {
		name:"sectorSetup",
		components: {
			ToutiaoAdvData,
			BaixinData,
			ChangkaihuaData,
		},
		computed: {
			...mapGetters([
				'userInfo', 'token'
			]),
		},
		methods: {
			...mapActions([
				'getUserInfo',
			]),
		}
	}
</script>

<style>
</style>
